<template>
  <div
    v-if="!hasSubmitted"
    data-component="ChatEmailInput"
    data-version="2"
    class="mt-2 flex flex-col w-full"
  >
    <form class="flex flex-col gap-2" @submit.prevent="onSubmit">
      <div>
        <CsInput
          :value="email"
          type="email"
          :placeholder="$t('EMAIL_PLACEHOLDER')"
          :is-clearable="false"
          :error="showError ? $t('CHAT_FORM.INVALID.EMAIL') : ''"
          @input="value => (email = value)"
        >
          <template #prefix>
            <CsIcon name="email" variant-color="secondary" class="mr-0.5" />
          </template>
        </CsInput>
      </div>

      <CsWidgetButton
        :bg-color="widgetColor"
        :text-color="textColor"
        :is-loading="isUpdating"
        :is-disabled="!isEmailValid"
        type="submit"
        class="w-full"
      >
        {{ $t('COMPONENTS.FORM_BUBBLE.SUBMIT') }}
      </CsWidgetButton>
    </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { getContrastingTextColor } from '@chatwoot/utils';

import { CsInput, CsIcon } from 'dashboard/components/ui/commslayer';
import CsWidgetButton from 'widget/v2/components/CsWidgetButton.vue';
import darkModeMixin from 'widget/mixins/darkModeMixin.js';

export default {
  components: {
    CsInput,
    CsWidgetButton,
    CsIcon,
  },
  mixins: [darkModeMixin],
  props: {
    messageId: {
      type: Number,
      required: true,
    },
    messageContentAttributes: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      email: '',
      isUpdating: false,
      hasAttemptedSubmit: false,
    };
  },
  computed: {
    ...mapGetters({
      widgetColor: 'appConfig/getWidgetColor',
    }),
    textColor() {
      return getContrastingTextColor(this.widgetColor);
    },
    hasSubmitted() {
      return (
        this.messageContentAttributes &&
        this.messageContentAttributes.submitted_email
      );
    },
    isEmailValid() {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(this.email);
    },
    showError() {
      return (
        this.hasAttemptedSubmit && !this.isEmailValid && this.email.length > 0
      );
    },
  },
  methods: {
    async onSubmit() {
      this.hasAttemptedSubmit = true;
      if (!this.isEmailValid) {
        return;
      }
      this.isUpdating = true;
      try {
        await this.$store.dispatch('message/update', {
          email: this.email,
          messageId: this.messageId,
        });
      } catch (error) {
        // Ignore error
      } finally {
        this.isUpdating = false;
      }
    },
  },
};
</script>
